import { z } from 'zod';

import { parseConfig } from './parse-config';

export const environmentLockAccessSchema = z.string().optional();

export const environmentLockAccess = parseConfig(
    'environment lock configuration',
    environmentLockAccessSchema,
    process.env.ENVIRONMENT_LOCK_ACCESS,
);
